/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.getPublicPromotions.internal

import features.getPublicPromotions.models.PromotionsModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest
import kangaroorewards.appsdk.core.network.base.PathParameter
import kangaroorewards.appsdk.core.network.base.replaceInPath

internal class GetPublicPromotionsRequest : NetworkRequest() {

    suspend fun getPublicPromotions(
        overrideHeaders: Map<String, String>? = null,
        campaignId: String
    ): IOResult<PromotionsModel> {
        return safeNetworkCall {
            get(
                endpoint = GetPublicPromotionsEndpoint.replaceInPath(
                    PathParameter("campaignId", campaignId),
                ),
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
